<template>
  <div
    v-if="isValid"
    class="bear-coupon-container item-print"
    :class="printMode"
    style="display: block; color: #000000"
  >
    <div
      v-if="printMode === 'K80'"
      style="
        padding-top: 10px;
        border-bottom: 1px dashed black;
        padding-bottom: 15px;
      "
    >
      <div style="border-top: 2px dashed black; padding-top: 15px"></div>
      <h5
        class="text-center"
        style="font-size: 20px; font-weight: bold; margin-bottom: 5px"
      >
        PHIẾU MUA HÀNG TRỊ GIÁ 100.000Đ
      </h5>
      <p
        class="text-center"
        style="font-size: 16px; font-weight: 600; margin-bottom: 10px"
      >
        Mã: BEAR_100K
      </p>
      <div style="font-size: 14px; margin-top: 10px; line-height: 1.5">
        <p style="font-weight: 600; margin-bottom: 5px">Điều kiện sử dụng:</p>
        <ul style="padding-left: 15px; margin-bottom: 5px; list-style: inherit">
          <li>
            Áp dụng khi mua đơn hàng Gia dụng Bear từ 500K tại hệ thống cửa hàng
            Di Động Việt
          </li>
          <li>
            Không áp dụng đồng thời chương trình khuyến mãi và phiếu mua hàng
            cùng loại khác
          </li>
        </ul>
        <p style="font-weight: 600; margin-bottom: 5px">Thời gian áp dụng:</p>
        <p>Từ 01/04 – 30/04</p>
        <p>Áp dụng toàn hệ thống DDV trên toàn quốc</p>
        <br />
        <p style="font-style: italic">
          Khách hàng có thể liên hệ hotline 18006018 (miễn phí) hoặc nhân viên
          tại cửa hàng để được hỗ trợ.
        </p>
      </div>
    </div>

    <div
      v-if="printMode === 'A4'"
      style="
        page-break-before: always;
        border-top: 2px dashed black;
        padding-top: 20px;
        margin-top: 20px;
        text-align: left;
        width: 100%;
        border-bottom: 2px dashed black;
        padding-bottom: 20px;
      "
    >
      <h5
        class="text-center"
        style="font-size: 24px; font-weight: bold; margin-bottom: 10px"
      >
        PHIẾU MUA HÀNG TRỊ GIÁ 100.000Đ
      </h5>
      <p
        class="text-center"
        style="font-size: 20px; font-weight: 600; margin-bottom: 15px"
      >
        Mã: BEAR_100K
      </p>
      <div style="font-size: 18px; margin-top: 10px; line-height: 1.5">
        <p style="font-weight: 600; margin-bottom: 5px">Điều kiện sử dụng:</p>
        <ul
          style="padding-left: 20px; margin-bottom: 10px; list-style: inherit"
        >
          <li>
            Áp dụng khi mua đơn hàng Gia dụng Bear từ 500K tại hệ thống cửa hàng
            Di Động Việt
          </li>
          <li>
            Không áp dụng đồng thời chương trình khuyến mãi và phiếu mua hàng
            cùng loại khác
          </li>
        </ul>
        <p style="font-weight: 600; margin-bottom: 5px">Thời gian áp dụng:</p>
        <p>Từ 01/04 – 30/04</p>
        <p>Áp dụng toàn hệ thống DDV trên toàn quốc</p>
        <br />
        <p style="font-style: italic">
          Khách hàng có thể liên hệ hotline 18006018 (miễn phí) hoặc nhân viên
          tại cửa hàng để được hỗ trợ.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bill: {
      type: Object,
      required: true,
    },
    printMode: {
      type: String,
      default: 'K80',
    },
  },
  computed: {
    isValid() {
      if (!this.bill) return false;
      const isDDV = this.bill.storeName && this.bill.storeName.includes('DDV');
      const isOver500k = this.bill.totalAmount >= 500000;
      return isDDV && isOver500k;
    },
  },
};
</script>
<style scoped>
p {
  margin-bottom: 0.5rem;
}
ul {
  margin-bottom: 0.5rem;
}
</style>
